export default __webpack_public_path__ + "static/media/buddy-datapad.64f8daa3.png";